import React from "react";
import { motion } from "framer-motion";
import { MapPin, Users, ArrowUpRight } from "lucide-react";

const VenueCard = ({ venue, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      className="group relative overflow-hidden rounded-[1.0rem] bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-white/5 flex flex-col md:flex-row shadow-sm hover:shadow-xl transition-all duration-500"
    >
      {/* Image Container */}
      <div className="md:w-2/5 h-64 md:h-auto overflow-hidden">
        <img 
          src={venue.image} 
          alt={venue.name} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
        />
      </div>

      {/* Content Container */}
      <div className="md:w-3/5 p-8 flex flex-col justify-between">
        <div>
          <div className="flex justify-between items-start mb-4">
            <span className="px-4 py-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-[10px] font-black uppercase tracking-widest rounded-full">
              {venue.type}
            </span>
            <a 
              href={venue.mapUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-blue-600 transition-colors"
            >
              <ArrowUpRight size={20} />
            </a>
          </div>
          
          <h3 className="text-xl font-black text-slate-800 dark:text-white uppercase tracking-tight mb-2">
            {venue.name}
          </h3>
          
          <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6 line-clamp-3">
            {venue.description}
          </p>
        </div>

        {/* Footer Info */}
        <div className="flex items-center gap-6 pt-6 border-t border-slate-200 dark:border-white/5">
          <div className="flex items-center gap-2">
            <MapPin size={16} className="text-blue-500" />
            <span className="text-xs font-bold text-slate-600 dark:text-slate-300">
              {venue.location.split(',')[0]} {/* Ambil area saja */}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Users size={16} className="text-blue-500" />
            <span className="text-xs font-bold text-slate-600 dark:text-slate-300">
              {venue.capacity} Capacity
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default VenueCard;